
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reset-password",
      function () {
        return require("private-next-pages/reset-password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reset-password"])
      });
    }
  